<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      sm="12"
      md="12"
      lg="12"
    >
      <b-overlay
        id="overlay-background-documents"
        :show="statementLoader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card
          :id="`debt-statements`"
        >
          <b-card-header
            class="base-document-header"
          >
            <b-card-title>{{ $t('DEBTIA_STATEMENTS') }}</b-card-title>
            <!-- <b-card-title class="text-primary"> -->
            <!-- <drag-links
                :parent="1"
                :side="side"
                :custom-change="customChange"
              /> -->
            <!-- </b-card-title> -->
            <div class="d-flex align-items-center ml-auto gap-1">
              <b-card-title
                v-if="(!caseStatus || caseStatus === 0 || caseStatus === 1 || caseStatus === 4) && !isCaseFullyPaid"
                class="text-primary mr-1"
              >
                <b-button
                  id="edit-statements"
                  v-b-modal.modal-pay-directly-to-client
                  variant="primary"
                  @click="payToClientDirectly()"
                >
                  <span class="text-nowrap">{{ '+ ' + $t('DEBTIA_PAY_DIRECTLY_TO_CLIENT') }}</span>
                </b-button>
              </b-card-title>
              <b-card-title
                v-if="$ability.can(constants.action.permissionEditStatements, constants.resource.user)"
                class="text-primary"
              >
                <b-button
                  id="edit-statements"
                  v-b-modal.modal-edit-statements
                  variant="primary"
                  @click="changeBtn()"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_CHANGE_STATEMENT') }}</span>
                </b-button>
              </b-card-title>
            </div>
          </b-card-header>
          <b-table
            :fields="statementsTableFields"
            :items="statementsData"
            striped
            responsive
            table-class="parent-table"
          >
            <template #cell(category)="row">
              <b-link
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                @click="row.toggleDetails"
              >
                {{ ($i18n.locale === 'en') ? row.item.en_name : row.item.da_name }}
              </b-link>
            </template>
            <template #row-details="row">
              <b-table
                :fields="statementCostDocumentsTableFields"
                :items="getEntries(row.item.statements)"
                striped
                responsive
                thead-class="d-none"
                table-class="child-table"
              >
                <template #cell(jobTaskNo)="cost">
                  <b-link
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="flat-primary"
                    @click="cost.toggleDetails"
                  >
                    {{ ($i18n.locale === 'en') ? cost.item.en_name : cost.item.da_name }}
                  </b-link>
                </template>
                <template #cell(totalAmount)="cost">
                  {{ formatCurrency(cost.item.scheduleTotalPrice) }}
                </template>
                <template #cell(paidAmount)="cost">
                  {{ formatCurrency(cost.item.paidAmount) }}
                </template>
                <template #cell(restAmount)="cost">
                  {{ formatCurrency(cost.item.scheduleTotalPrice - cost.item.paidAmount) }}
                </template>
              </b-table>
            </template>
            <template #cell(totalAmount)="row">
              {{ formatCurrency(row.item.totalAmount) }}
            </template>
            <template #cell(paidAmount)="row">
              {{ formatCurrency(row.item.paidAmount) }}
            </template>
            <template #cell(restAmount)="row">
              {{ formatCurrency(row.item.restAmount) }}
            </template>
          </b-table>
          <label>{{ 'Termsheet: ' + termSheetCode }}</label>
        </b-card>
        <edit-statements-modal
          :case-id="caseId"
          :statements-amount="statementsAmount"
          :show-bailif-checkbox="showBailifCheckbox"
          :bailif-value="bailifValue"
          :disable-bailif="disableBailif"
          :click-change="editStatementModalClicked"
          :get-statements="getStatements"
        />
        <pay-directly-to-client-modal
          :case-id="caseId"
          :click-change="payToClientDirectlyModalClicked"
          :get-statements="getStatements"
          :client-bc-customer-id="clientBcCustomerId"
        />
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BLink, BTable, BCardHeader, BCardTitle, BButton, BOverlay,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import constants from '@/app-configs/constants'
import axios from '@axios'
import { EventBus } from '@/event-bus'
import i18n from '@/libs/i18n'
import EditStatementsModal from '../EditStatementsModal.vue'
import PayDirectlyToClientModal from '../PayDirectlyToClientModal.vue'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BLink,
    BTable,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    // DragLinks,
    BCardHeader,
    BCardTitle,
    EditStatementsModal,
    BButton,
    BOverlay,
    PayDirectlyToClientModal,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      statementLoader: true,
      statementsData: [],
      defaultCurrency: localStorage.getItem('defaultCurrency'),
      constants,
      caseId: this.$route.params.id,
      statementsAmount: [],
      showBailifCheckbox: true,
      bailifValue: true,
      disableBailif: true,
      editStatementModalClicked: false,
      payToClientDirectlyModalClicked: false,
      termSheetCode: '',
      clientBcCustomerId: '',
      caseStatus: '',
      isCaseFullyPaid: false,
    }
  },
  computed: {
    statementsTableFields() {
      return [
        { key: 'category', label: '', tdClass: 'text-left' },
        { key: 'totalAmount', label: i18n.t('DEBTIA_TOTAL_AMOUNT'), tdClass: 'text-right' },
        { key: 'paidAmount', label: i18n.t('DEBTIA_PAID_AMOUNT'), tdClass: 'text-right' },
        { key: 'restAmount', label: i18n.t('DEBTIA_REST_AMOUNT'), tdClass: 'text-right' },
      ]
    },
    statementCostDocumentsTableFields() {
      return [
        { key: 'jobTaskNo', label: '-', tdClass: 'text-left' },
        { key: 'totalAmount', label: '-', tdClass: 'text-right' },
        { key: 'paidAmount', label: '-', tdClass: 'text-right' },
        { key: 'restAmount', label: '-', tdClass: 'text-right' },
      ]
    },
  },
  created() {
    EventBus.$on('refreshStatmentWidget', () => {
      this.getStatements()
    })
  },
  methods: {
    async fetchInitialData() {
      await this.getStatements()
    },
    changeBtn() {
      this.editStatementModalClicked = !this.editStatementModalClicked
    },
    payToClientDirectly() {
      this.payToClientDirectlyModalClicked = !this.payToClientDirectlyModalClicked
    },
    getEntries(data) {
      const arr = []
      Object.entries(data).forEach(value => {
        arr.push(value[1])
      })
      return arr
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: this.defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    async openLink(href) {
      window.open(href, '_blank')
    },
    async getStatements() {
      this.statementLoader = true
      this.statementsAmount = []
      const url = `${constants.baseUrlV2}/debt-case/statements-data/${this.caseId}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.statementLoader = false
          this.statementsData = response.data.data.statements
          this.termSheetCode = response.data.data.termSheetCode
          this.clientBcCustomerId = response.data.data.clientBcCustomerId
          this.caseStatus = response.data.data.caseStatus
          this.isCaseFullyPaid = response.data.data.isCaseFullyPaid || false
          this.showBailifCheckbox = true
          this.bailifValue = true
          this.disableBailif = true
          EventBus.$emit('setRemainingDebtAmount', response.data.data.remainingDebtAmount)
          EventBus.$emit('isCaseFullyPaid', response.data.data.isCaseFullyPaid)
          // computation for getting the statement values for edit statement model
          const statementsKeysRow = []
          this.statementsData.forEach(statementGroupValue => {
            if (typeof statementGroupValue.statements !== 'undefined') {
              Object.values(statementGroupValue.statements).forEach(key => {
                if (response.data.data.statementKeys.includes(key.jobTaskNo)) {
                  if (!statementsKeysRow.includes(key.jobTaskNo)) {
                    statementsKeysRow.push(key.jobTaskNo)
                    this.statementsAmount.push(key)
                  }
                }
              })
            } else if (statementGroupValue.en_name !== 'Sum' || statementGroupValue.da_name !== 'Sum') {
              const defaultStatementLine = {}
              defaultStatementLine.en_name = statementGroupValue.en_name
              defaultStatementLine.da_name = statementGroupValue.da_name
              defaultStatementLine.jobTaskNo = statementGroupValue.jobTaskNo
              defaultStatementLine.scheduleTotalPrice = statementGroupValue.totalAmount
              defaultStatementLine.paidAmount = statementGroupValue.paidAmount
              this.statementsAmount.push(defaultStatementLine)
            }
          })
        }
      }).catch(() => {
        this.statementLoader = false
        EventBus.$emit('isCaseFullyPaid', false)
      })
    },
  },
}
</script>

<style lang="scss">
</style>
